import type { IBeneficiary, IUseFormStage } from 'BreetHelpers';

export type AUTOSETTLEMENTSTAGE = 'destination' | 'otpverification';

export const autoSettlementStageTitle: Record<AUTOSETTLEMENTSTAGE, string> = {
	destination: 'Select Account Settlement',
	otpverification: '',
};

export interface IAutomaticSettlementDestination {
	updateAutoSettlement: () => void;
	selectedBeneficiary?: IBeneficiary;
}

export interface IAutomaticSettlementAddDestination {
	onEnable: () => void;
	handleBeneficiarySelection: (selectedBeneficiaryArgs: IBeneficiary) => () => void;
	selectedBeneficiary: IBeneficiary | null;
}

export interface IAutomaticSettlementOTPVerification {
	onResend?: (restartCountDown?: () => void) => void;
	onOTPInput?: (otp: string) => void;
	onSubmit?: () => void;
	isLoading?: boolean;
}

export interface IDialogAutoSettlement {
	handleAutomaticSettlement: (onSuccess?: () => void) => void;
	handleBeneficiarySelection: (selectedBeneficiaryArgs: IBeneficiary | undefined) => void;
	formStageProps: IUseFormStage<AUTOSETTLEMENTSTAGE>;
	selectedBeneficiary: IBeneficiary | undefined;
}
